interface Props {
  end: string
  days: number
  maxDate: string
  onChange: (next: { end?: string; days?: number }) => void
  disabled?: boolean
}

const PRESETS = [
  { days: 7, label: 'Last 7 days' },
  { days: 14, label: 'Last 14 days' },
  { days: 28, label: 'Last 28 days' },
  { days: 90, label: 'Last 90 days' },
]

/**
 * Window controls.
 *
 * `maxDate` is the most recent settled day. GA4 keeps collecting for a day well past
 * midnight, so allowing a more recent end date would show numbers that change under
 * the reader.
 */
export function WindowPicker({ end, days, maxDate, onChange, disabled }: Props) {
  return (
    <div className="controls">
      <label className="field">
        <span className="field__label">Range</span>
        <select
          value={days}
          disabled={disabled}
          onChange={(event) => onChange({ days: Number(event.target.value) })}
        >
          {PRESETS.map((preset) => (
            <option key={preset.days} value={preset.days}>
              {preset.label}
            </option>
          ))}
        </select>
      </label>

      <label className="field">
        <span className="field__label">Ending</span>
        <input
          type="date"
          value={end}
          max={maxDate}
          disabled={disabled}
          onChange={(event) => {
            if (event.target.value) onChange({ end: event.target.value })
          }}
        />
      </label>
    </div>
  )
}
